<!-- Component for testing purpose  -->
<h1>Welcome to template Pensionados web component!</h1>
<a routerLink="home">Pensionados web Component</a>